import { render, staticRenderFns } from "./hjcxcgPhone.vue?vue&type=template&id=14dcfdbc&"
import script from "./hjcxcgPhone.vue?vue&type=script&lang=js&"
export * from "./hjcxcgPhone.vue?vue&type=script&lang=js&"
import style0 from "./hjcxcgPhone.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports